<template>
  <div @mousemove="handleMouseMove">
    <div class="background">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 1080">
        <g id="saturn" @click="showHidden = !showHidden">
          <path
            class="cls-2"
            fill="#fff"
            d="M819.27,538c-9.57-11.47-22.6-19.67-36.58-24.64s-28.89-7.26-43.73-7.81a251.59,251.59,0,0,0-44.47,2.6A411,411,0,0,0,650.8,517c-28.83,7.31-56.86,17.43-84.32,28.75S512.26,570.08,486,583.94c-52.48,27.85-102.75,59.7-151.1,94.09s-94.73,71.5-139.35,110.48S108.24,868.6,67.78,911.65s-78.73,88-113.59,135.27q-26.14,35.43-49.12,72.72a647,647,0,0,0-40.56,76.67c-11.47,26.18-20.72,53.33-24.34,80.12-1.83,13.35-2,26.57.09,38.67s6.68,22.88,13.88,31.39a68.49,68.49,0,0,0,12.58,11.21c1.2.8,2.49,1.49,3.72,2.26l1.87,1.12,2,1c1.35.63,2.65,1.33,4,1.93l4.27,1.65a40.53,40.53,0,0,0,4.4,1.47c1.5.44,3,.94,4.49,1.34l4.67,1.07,2.33.54,2.42.38,4.81.79c1.62.25,3.29.36,4.93.55s3.28.39,4.95.48l5,.24c27,1.09,55.35-3.22,83.12-9.93,13.93-3.34,27.79-7.38,41.56-11.84s27.47-9.34,41-14.69c27.14-10.59,53.87-22.65,80.2-35.59a1492,1492,0,0,0,153.06-88.14q74.17-48.46,143.64-104.18c46.2-37.08,90.79-76.28,133.2-117.8,21.17-20.78,41.82-42.12,61.7-64.17s39.2-44.63,57.43-68.08,35.75-47.48,51.73-72.53c8-12.54,15.74-25.22,22.93-38.23s14.1-26.17,20.19-39.73a413.45,413.45,0,0,0,16.3-41.48,250,250,0,0,0,10.36-43.32l.75-5.53.46-5.55c.4-3.7.39-7.42.5-11.14.1-1.86,0-3.71-.09-5.57l-.23-5.57-.6-5.55-.3-2.77-.51-2.74-1-5.48-1.47-5.38c-.26-.89-.47-1.8-.76-2.68l-1-2.62c-.68-1.73-1.23-3.52-2-5.2A85.35,85.35,0,0,0,819.27,538Zm0,0A85.41,85.41,0,0,1,831,557c.78,1.69,1.34,3.47,2,5.2l1,2.62c.3.88.51,1.79.77,2.68l1.49,5.38,1,5.49.52,2.74.31,2.78.63,5.55L839,595c.07,1.86.2,3.72.11,5.58-.1,3.73-.07,7.45-.46,11.16l-.44,5.57-.72,5.54c-4.07,29.56-13.91,58-25.8,85.3a674.81,674.81,0,0,1-41.82,79L764,796.62l-6,9.41c-4,6.31-8.2,12.46-12.3,18.69-8.42,12.31-17,24.55-25.86,36.51s-18,23.81-27.16,35.58-18.69,23.28-28.35,34.65c-19.28,22.79-39.09,45.16-59.62,66.87q-61.41,65.26-129.11,124.43c-45.06,39.38-91.95,76.79-140.84,111.61s-99.81,67-153.14,95.33c-26.72,14-53.93,27.35-82.06,38.89q-21,8.79-42.73,16.28c-7.2,2.54-14.52,4.85-21.84,7.13s-14.76,4.3-22.26,6.17a425.85,425.85,0,0,1-45.76,9.19,265.77,265.77,0,0,1-47.77,2.74l-6.11-.28c-2-.11-4.1-.38-6.16-.56s-4.1-.37-6.16-.67l-6.21-1-3.1-.5-3.11-.69-6.22-1.4c-2.07-.54-4.14-1.21-6.21-1.81s-4.13-1.22-6.18-2l-6.15-2.37c-2-.87-4-1.89-6.05-2.84l-3-1.46-2.93-1.71c-2-1.17-3.92-2.27-5.82-3.53A103.24,103.24,0,0,1-175,1370.87a96.62,96.62,0,0,1-14.46-23.57,112.3,112.3,0,0,1-7.53-25.69c-2.93-17.26-2.37-34.17-.12-50.26s6.29-31.58,11.1-46.54a426.09,426.09,0,0,1,17.08-43.43c12.74-28.14,28-54.66,44.34-80.29s34.18-50.11,52.71-73.93C-34.63,979.61,6,935.16,48.84,893.1S136.76,811.5,183.41,774s95.09-72.65,145.1-105.33,101.65-62.86,155.12-89.36c26.75-13.23,54-25.41,81.75-36.34a670.56,670.56,0,0,1,85.1-27.32c28.93-7,58.67-11.65,88.49-10.47,14.87.6,29.77,2.9,43.79,8S809.75,526.51,819.27,538Z"/>
          <circle class="cls-3" fill="#ff3e6c" cx="329.44" cy="948.35" r="362.44"/>
          <path
            class="cls-2"
            fill="#fff"
            d="M67.78,911.65c40.46-43,83.19-84.11,127.76-123.14s91-76,139.35-110.48c36.3-25.82,73.69-50.21,112.28-72.55q-4.2-1.44-8.44-2.78c-37.62,20.43-74.35,42.55-110.22,66q-75,49-145.1,105.33C136.76,811.5,91.7,851.09,48.84,893.1,20.94,920.51-6,949-31.74,978.6a364.25,364.25,0,0,0,5.94,42C3.53,982.88,34.91,946.6,67.78,911.65Z"/>
        </g>
      </svg>
    </div>

    <div class="container">
      <img src="../img/title.svg" alt="Title">
      <div class="apps" v-if="showHidden">
        <div class="app">
          <a class="nav-link active" target="_blank" href="http://apps.marstanjx.com/japanese">
            <img src="../icon/japanese-2.svg" class="app-icon" alt="japanese">
            <h2 class="app-name">Japanese (Legacy)</h2>
          </a>
        </div>
        <div class="app">
          <router-link class="nav-link active" to="isaac">
            <img src="../icon/isaac.svg" class="app-icon" alt="isaac">
            <h2 class="app-name">Isaac</h2>
          </router-link>
        </div>
      </div>
      <div class="apps" v-else>
        <div class="app">
          <a class="nav-link active" href="http://marstanjx.com/">
            <img src="../icon/mars.svg" class="app-icon" alt="mars inc">
            <h2 class="app-name">Mars Inc</h2>
          </a>
        </div>
        <div class="app">
          <router-link class="nav-link active" to="log">
            <img src="../icon/log.svg" class="app-icon" alt="log">
            <h2 class="app-name">Log</h2>
          </router-link>
        </div>
        <div class="app">
          <router-link class="nav-link active" to="event">
            <img src="../icon/event.svg" class="app-icon" alt="event">
            <h2 class="app-name">Event</h2>
          </router-link>
        </div>
        <div class="app">
          <router-link class="nav-link active" to="progress">
            <img src="../icon/progress.svg" class="app-icon" alt="progress">
            <h2 class="app-name">Progress</h2>
          </router-link>
        </div>
        <div class="app">
          <router-link class="nav-link active" to="music">
            <img src="../icon/music.svg" class="app-icon" alt="music">
            <h2 class="app-name">Scale</h2>
          </router-link>
        </div>
        <div class="app">
          <a class="nav-link active" target="_blank" href="https://notes.marstanjx.com">
            <img src="../icon/japanese.svg" class="app-icon" alt="japanese">
            <h2 class="app-name">Japanese</h2>
          </a>
        </div>
      </div>
      <p>Mars Inc Apps is under maintenance</p>
    </div>

    <div class="container login">
      <p v-if="isLoggedIn">Hello, Mars</p>
      <router-link v-else to="login">Login</router-link>
    </div>
  </div>
</template>

<script>

import { checkToken } from '../data';

export default {
  name: 'home',
  data() {
    return {
      isLoggedIn: false,
      showHidden: false,
    };
  },
  mounted() {
    this.isLoggedIn = checkToken();
  },
  methods: {
    handleMouseMove(event) {
      const w = document.body.clientWidth;
      const h = document.body.clientHeight;
      const wp = event.clientX / w;
      const wh = event.clientY / h;
      document.querySelector('#saturn').style.transform = `translate(${wp * -15}px, ${wh * -20}px)`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../styles/index";
</style>
